<template>
    <el-tabs type="card" style="padding: 10px">
        <!-- @tab-click="handleClick" -->
        <el-tab-pane label="服务器列表">
            <el-row>
                <el-button-group>
                    <el-button round type="success" size="small" @click="openCreateMachine">创建</el-button>
                </el-button-group>
            </el-row>
            <el-row style="padding: 30px">
                <el-col :span="24">
                    <el-collapse accordion @change="showCmdList">
                        <el-collapse-item v-for="item in currentMachineList" :key="item.id.toString()" :index="item.id"
                            :title="item.name" :name="item.id">
                            <template #title>
                                <div>
                                    <span style="font-weight: bold; font-size: 18px; color: #000">{{ item.name }}</span>
                                    <span style="font-weight: bold; font-size: 18px; color: #888">（{{ item.address
                                        }}）</span>
                                </div>
                            </template>
                            <div style="padding-left: 30px; margin-left: 15px; border-left: 3px solid #ccc">
                                <div>
                                    {{ item.description }}
                                    <el-button type="text" round size="small"
                                        @click="openEditMachine(item.id)">[编辑服务器信息]</el-button>
                                    <el-popover placement="top-start" :width="200" trigger="click">
                                        <p>删除操作不可撤回，确定删除吗？</p>
                                        <div style="text-align: right; margin: 0">
                                            <el-button type="danger" size="mini"
                                                @click="deleteMachine(item.id)">确定</el-button>
                                        </div>
                                        <template #reference>
                                            <el-button type="text" round size="small"
                                                style="color: #f56c6c">[删除服务器信息]</el-button>
                                        </template>
                                    </el-popover>
                                </div>
                                <div>&nbsp;</div>
                                <div>
                                    <el-button type="success" round size="small"
                                        @click="openCreateCmd(item.id)">创建指令</el-button>
                                </div>
                                <div>
                                    <el-table :data="this.currentCmdList" style="width: 100%">
                                        <el-table-column prop="name" label="名称"></el-table-column>
                                        <!-- <el-table-column prop="description" label="描述信息"></el-table-column> -->
                                        <!-- <el-table-column prop="createTime" label="创建时间"></el-table-column> -->
                                        <el-table-column prop="type" label="类型" width="80"></el-table-column>
                                        <el-table-column prop="contentTa" label="contentTa"></el-table-column>
                                        <!-- <el-table-column prop="contentTb" label="contentTb"></el-table-column>
                                    <el-table-column prop="contentTc" label="contentTc"></el-table-column> -->
                                        <el-table-column fixed="right" label="操作" width="100">
                                            <template #default="scope">
                                                <el-button type="success" round size="small"
                                                    @click="runCmd(scope.row)">执行</el-button>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="管理" width="200">
                                            <template #default="scope">
                                                <el-button type="warning" round size="small"
                                                    @click="openEditCmd(scope.row)">编辑</el-button>
                                                <!-- <el-button type="warning" round size="small" @click="openCreateCmd(scope.row)">编辑</el-button> -->
                                                <el-popover placement="top-start" :width="200" trigger="click">
                                                    <p>删除操作不可撤回，确定删除吗？</p>
                                                    <div style="text-align: right; margin: 0">
                                                        <el-button type="danger" size="mini"
                                                            @click="deleteCmd(scope.row)">确定</el-button>
                                                    </div>
                                                    <template #reference>
                                                        <el-button type="danger" round size="small">删除</el-button>
                                                    </template>
                                                </el-popover>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-row>
        </el-tab-pane>

        <el-tab-pane label="执行日志">
            <el-row style="padding: 50px">
                <el-col :span="24">
                    <div class="exe-log-search">
                        <el-input v-model="searchDataParams.planName" placeholder="执行服务器" clearable
                            @keydown="searchDataEnter" />
                        <el-input v-model="searchDataParams.dataSource" placeholder="执行命令" clearable
                            @keydown="searchDataEnter" />
                        <el-input v-model="searchDataParams.ip" placeholder="执行人" clearable
                            @keydown="searchDataEnter" />
                        <el-button type="primary" @click="searchData()">
                            <el-icon>
                                <Search />
                            </el-icon>
                            搜索
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-table :data="exeLogList" style="width: 100%" stripe>
                        <el-table-column label="执行时间" width="180">
                            <template #default="scope">
                                <div class="exe-log-time">
                                    <span>{{ scope.row.beginTime }}</span>
                                    <span>{{ scope.row.endTime }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="执行服务器" min-width="200">
                            <template #default="scope">
                                <span v-if="scope.row.machine">
                                    {{ scope.row.machine.name }}
                                    <span class="exe-log-address">[{{ scope.row.machine.address }}]</span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="执行命令" min-width="180">
                            <template #default="scope">
                                {{ scope.row.cmd ? scope.row.cmd.name : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="执行人" width="120">
                            <template #default="scope">
                                {{ scope.row.runUser ? scope.row.runUser.realName : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template #default="scope">
                                <el-button type="text" round size="small"
                                    @click="exeLogDetail(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="exe-log-pagination">
                        <el-pagination background layout="total, prev, pager, next, jumper" :total="exeLogPage.total"
                            :current-page="exeLogPage.current" :page-size="exeLogPage.size"
                            @current-change="handleExeLogPageChange" />
                    </div>
                </el-col>
            </el-row>
        </el-tab-pane>
    </el-tabs>

    <!-- Form -->
    <el-dialog :title="this.machineForm.mode == 'create' ? '创建服务链接' : '编辑服务链接'" v-model="this.machineForm.dialog">
        <el-form :model="this.machineForm.prop">
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input v-model="this.machineForm.prop.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" :label-width="formLabelWidth">
                <el-input type="textarea" :rows="2" placeholder="请输入内容"
                    v-model="this.machineForm.prop.description"></el-input>
            </el-form-item>
            <el-form-item label="类型" :label-width="formLabelWidth">
                <el-select v-model="this.machineForm.prop.type" placeholder="请选择">
                    <el-option v-for="item in machineTypeSelect" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="地址" :label-width="formLabelWidth">
                <el-input v-model="this.machineForm.prop.address" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="端口" :label-width="formLabelWidth">
                <el-input v-model="this.machineForm.prop.port" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="账号" :label-width="formLabelWidth">
                <el-input v-model="this.machineForm.prop.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="formLabelWidth">
                <el-input v-model="this.machineForm.prop.password" autocomplete="off" show-password></el-input>
            </el-form-item>
            <el-form-item label="生产防护锁" :label-width="formLabelWidth">
                <el-switch v-model="this.machineForm.prop.prodLock" />
                <span class="tips">开启后将启用生产环境防护</span>
            </el-form-item>
            <el-form-item label="团队" :label-width="formLabelWidth">
                <el-select v-model="this.machineForm.prop.teamIdList" multiple placeholder="可选择已加入的团队"
                    style="width: 300px">
                    <el-option v-for="item in this.team.myJoin" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <span class="tips">私有 或 团队可见</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="this.machineForm.dialog = false">取 消</el-button>
                <el-button type="primary" @click="saveMachine">保 存</el-button>
            </span>
        </template>
    </el-dialog>

    <!-- Form -->
    <el-dialog :title="this.cmdForm.mode == 'create' ? '创建服务指令' : '编辑服务指令'" v-model="this.cmdForm.dialog">
        <el-form :model="this.cmdForm.prop">
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input v-model="this.cmdForm.prop.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述" :label-width="formLabelWidth">
                <el-input type="textarea" :rows="2" placeholder="请输入内容"
                    v-model="this.cmdForm.prop.description"></el-input>
            </el-form-item>
            <el-form-item label="类型" :label-width="formLabelWidth">
                <el-select v-model="this.cmdForm.prop.type" placeholder="请选择">
                    <el-option v-for="item in cmdTypeSelect" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="指令a" :label-width="formLabelWidth">
                <el-input type="textarea" :rows="2" placeholder="请输入内容"
                    v-model="this.cmdForm.prop.contentTa"></el-input>
            </el-form-item>
            <el-form-item label="指令b" :label-width="formLabelWidth">
                <el-input type="textarea" :rows="2" placeholder="请输入内容"
                    v-model="this.cmdForm.prop.contentTb"></el-input>
            </el-form-item>
            <el-form-item label="指令c" :label-width="formLabelWidth">
                <el-input type="textarea" :rows="2" placeholder="请输入内容"
                    v-model="this.cmdForm.prop.contentTc"></el-input>
            </el-form-item>
            <el-form-item label="监控端口" :label-width="formLabelWidth">
                <el-input-number v-model="this.cmdForm.prop.port" :min="0" :max="65535" />
            </el-form-item>
            <el-form-item label="共享使用" :label-width="formLabelWidth">
                <el-switch v-model="this.cmdForm.prop.isShare" />
            </el-form-item>
            <el-form-item label="执行间隔" :label-width="formLabelWidth">
                <el-input-number v-model="this.cmdForm.prop.interval" :min="0" :max="3600" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="this.cmdForm.dialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCmd">保 存</el-button>
            </span>
        </template>
    </el-dialog>

    <!-- fileDetail -->
    <el-dialog v-model="this.exeLogDialog.dialog" title="日志文件详情" width="90%" center fullscreen>
        <el-descriptions :column="2" border size="small" class="exe-log-detail">
            <el-descriptions-item label="执行服务器">
                {{ exeLogDialog.current.machine ? exeLogDialog.current.machine.name + ' [' +
                    exeLogDialog.current.machine.address + ']' : '' }}
            </el-descriptions-item>
            <el-descriptions-item label="执行命令">
                {{ exeLogDialog.current.cmd ? exeLogDialog.current.cmd.name : '' }}
            </el-descriptions-item>
            <el-descriptions-item label="脚本a" :span="2">
                <span class="exe-log-script">{{ exeLogDialog.current.contentTa }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="脚本a结果" :span="2">
                {{ exeLogDialog.current.resultTa }}
            </el-descriptions-item>
        </el-descriptions>
        <el-container>
            <el-main>
                <v-md-editor v-model="this.exeLogDialog.current.fileDetail" mode="preview" ref="editor"
                    @copy-code-success="handleCopyCodeSuccess" />
            </el-main>
        </el-container>
        <template #footer>
            <span class="dialog-footer">
                <el-affix position="bottom" :offset="20">
                    <el-button type="primary" @click="this.exeLogDialog.dialog = false"
                        style="width: 300px">关闭</el-button>
                </el-affix>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';
import { Search, Share, Guide } from '@element-plus/icons';
export default {
    data() {
        return {
            machineForm: {
                mode: 'create',
                dialog: false,
                prop: {
                    name: '',
                    description: '',
                    type: '',
                    address: '',
                    port: 0,
                    username: '',
                    password: '',
                    prodLock: false,
                    teamIdList: []
                }
            },
            cmdForm: {
                mode: 'create',
                dialog: false,
                prop: {
                    machineId: '',
                    name: '',
                    description: '',
                    type: '',
                    contentTa: '',
                    contentTb: '',
                    contentTc: '',
                    port: 0,
                    isShare: false
                }
            },
            currentMachineId: '',
            currentMachineList: [],
            currentCmdList: [],
            exeLogDialog: {
                dialog: false,
                current: {
                    fileDetail: '',
                    machine: null,
                    cmd: null,
                    contentTa: '',
                    resultTa: ''
                }
            },
            exeLogList: [],
            exeLogPage: {
                current: 1,
                size: 20,
                total: 0
            },
            searchDataParams: {
                createTime: '',
                planName: '',
                dataSource: '',
                ip: '',
                mac: '',
                senderId: '',
                senderName: '',
                dataString: ''
            },
            formLabelWidth: '120px',
            machineTypeSelect: [
                {
                    value: 'ssh',
                    label: 'ssh'
                }
            ],
            cmdTypeSelect: [
                {
                    value: '通用',
                    label: 'normal'
                }
            ],
            team: {
                myJoin: []
            }
        };
    },
    components: { Search },
    mounted() {
        this.loadMachine();
        this.loadExeLogList();
    },
    methods: {
        searchDataEnter(e) {
            if (e.keyCode == 13) {
                this.searchData();
            }
        },
        searchData() {
            this.exeLogPage.current = 1;
            return this.loadExeLogList();
        },
        handleExeLogPageChange(page) {
            this.exeLogPage.current = page;
            return this.loadExeLogList();
        },
        loadExeLogList() {
            return request({
                url: '/serverManExeLog/pageList',
                method: 'post',
                data: {
                    ...this.searchDataParams,
                    token: this.$store.state.user.token,
                    current: this.exeLogPage.current,
                    size: this.exeLogPage.size
                }
            }).then(res => {
                if (res.code == 0) {
                    this.exeLogList = res.data || [];
                    this.exeLogPage.total = res.total || 0;
                }
            });
        },
        showCmdList(machineId) {
            console.log('current change is: ' + machineId);
            this.currentMachineId = machineId;
            this.loadCmd();
        },
        openCreateMachine() {
            this.loadMyJoinTeam();

            // 清空表单数据
            this.machineForm.prop.name = '';
            this.machineForm.prop.description = '';
            this.machineForm.prop.type = '';
            this.machineForm.prop.address = '';
            this.machineForm.prop.port = '';
            this.machineForm.prop.username = '';
            this.machineForm.prop.password = '';
            this.machineForm.prop.prodLock = false;
            this.machineForm.prop.teamIdList = [];

            this.machineForm.mode = 'create';
            this.machineForm.dialog = true;
        },
        openEditMachine(machineId) {
            console.log('编辑主机信息');
            this.loadMyJoinTeam();

            return request({
                url: '/serverManMachine/get',
                method: 'post',
                data: { token: this.$store.state.user.token, id: machineId }
            }).then(res => {
                if (res.code == 0 && res.meta.serverManMachine) {
                    this.machineForm.prop = res.meta.serverManMachine;
                    this.machineForm.mode = 'edit';
                    this.machineForm.dialog = true;
                }
            });
        },
        loadMachine() {
            return request({
                url: '/serverManMachine/list',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.currentMachineList = res.meta.serverManMachines;
                    console.log(this.currentMachineList);
                }
            });
        },
        saveMachine() {
            if (this.machineForm.mode == 'create') {
                return request({
                    url: '/serverManMachine/create',
                    method: 'post',
                    data: {
                        name: this.machineForm.prop.name,
                        description: this.machineForm.prop.description,
                        type: this.machineForm.prop.type,
                        address: this.machineForm.prop.address,
                        port: this.machineForm.prop.port,
                        username: this.machineForm.prop.username,
                        password: this.machineForm.prop.password,
                        prodLock: this.machineForm.prop.prodLock,
                        teamIdList: this.machineForm.prop.teamIdList
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.machineForm.dialog = false;
                        this.loadMachine();
                    }
                });
            }
            if (this.machineForm.mode == 'edit') {
                return request({
                    url: '/serverManMachine/edit',
                    method: 'post',
                    data: {
                        id: this.machineForm.prop.id,
                        name: this.machineForm.prop.name,
                        description: this.machineForm.prop.description,
                        type: this.machineForm.prop.type,
                        address: this.machineForm.prop.address,
                        port: this.machineForm.prop.port,
                        username: this.machineForm.prop.username,
                        password: this.machineForm.prop.password,
                        prodLock: this.machineForm.prop.prodLock,
                        teamIdList: this.machineForm.prop.teamIdList
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.machineForm.dialog = false;
                        this.loadMachine();
                    }
                });
            }
        },
        deleteMachine(machineId) {
            return request({
                url: '/serverManMachine/delete',
                method: 'post',
                data: { token: this.$store.state.user.token, id: machineId }
            }).then(res => {
                if (res.code == 0) {
                    this.loadMachine();
                }
            });
        },
        openCreateCmd(machineId) {
            // 清空表单数据
            this.cmdForm.prop.machineId = machineId;
            this.cmdForm.prop.name = '';
            this.cmdForm.prop.description = '';
            this.cmdForm.prop.type = '';
            this.cmdForm.prop.contentTa = '';
            this.cmdForm.prop.contentTb = '';
            this.cmdForm.prop.contentTc = '';
            this.cmdForm.prop.port = 0;
            this.cmdForm.prop.isShare = false;
            this.cmdForm.prop.interval = 0;

            this.cmdForm.mode = 'create';
            this.cmdForm.dialog = true;
        },
        openEditCmd(row) {
            console.log('编辑指令信息');

            return request({
                url: '/serverManCmd/get',
                method: 'post',
                data: { token: this.$store.state.user.token, id: row.id }
            }).then(res => {
                if (res.code == 0 && res.meta.serverManCmd) {
                    this.cmdForm.prop = res.meta.serverManCmd;
                    this.cmdForm.mode = 'edit';
                    this.cmdForm.dialog = true;
                }
            });
        },
        loadCmd() {
            return request({
                url: '/serverManCmd/list',
                method: 'post',
                data: { token: this.$store.state.user.token, machineId: this.currentMachineId }
            }).then(res => {
                if (res.code == 0) {
                    this.currentCmdList = res.meta.serverManCmds;
                    console.log(this.currentCmdList);
                }
            });
        },
        saveCmd() {
            if (this.cmdForm.mode == 'create') {
                return request({
                    url: '/serverManCmd/create',
                    method: 'post',
                    data: {
                        machineId: this.cmdForm.prop.machineId,
                        name: this.cmdForm.prop.name,
                        description: this.cmdForm.prop.description,
                        type: this.cmdForm.prop.type,
                        contentTa: this.cmdForm.prop.contentTa,
                        contentTb: this.cmdForm.prop.contentTb,
                        contentTc: this.cmdForm.prop.contentTc,
                        port: this.cmdForm.prop.port,
                        isShare: this.cmdForm.prop.isShare,
                        interval: this.cmdForm.prop.interval
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.cmdForm.dialog = false;
                        this.loadCmd();
                    }
                });
            }
            if (this.cmdForm.mode == 'edit') {
                return request({
                    url: '/serverManCmd/edit',
                    method: 'post',
                    data: {
                        id: this.cmdForm.prop.id,
                        machineId: this.cmdForm.prop.machineId,
                        name: this.cmdForm.prop.name,
                        description: this.cmdForm.prop.description,
                        type: this.cmdForm.prop.type,
                        contentTa: this.cmdForm.prop.contentTa,
                        contentTb: this.cmdForm.prop.contentTb,
                        contentTc: this.cmdForm.prop.contentTc,
                        port: this.cmdForm.prop.port,
                        isShare: this.cmdForm.prop.isShare,
                        interval: this.cmdForm.prop.interval
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.cmdForm.dialog = false;
                        this.loadCmd();
                    }
                });
            }
        },
        deleteCmd(row) {
            return request({
                url: '/serverManCmd/delete',
                method: 'post',
                data: { token: this.$store.state.user.token, id: row.id }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    this.loadCmd();
                }
            });
        },
        runCmd(row) {
            console.log('runCmd: ' + row.id);
            return request({
                url: '/serverManCmd/run',
                method: 'post',
                data: { token: this.$store.state.user.token, id: row.id }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    ElMessage({
                        message: res.msg,
                        type: 'success',
                        duration: 5 * 1000
                    });
                }
            });
        },
        exeLogDetail(row) {
            this.exeLogDialog.current.machine = row.machine;
            this.exeLogDialog.current.cmd = row.cmd;
            this.exeLogDialog.current.contentTa = row.contentTa;
            this.exeLogDialog.current.resultTa = row.resultTa;
            return request({
                url: '/serverManExeLog/serverManOutput',
                method: 'post',
                data: { token: this.$store.state.user.token, dialogId: row.id, serialNumber: 1 }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                    let output = '';
                    for (let i = 0; i < res.data.length; i++) {
                        output = output + res.data[i].output;
                    }
                    this.exeLogDialog.current.fileDetail = '```bash' + '\r\n' + output + '\r\n' + '```';
                    this.exeLogDialog.dialog = true;
                }
            });
        },
        handleCopyCodeSuccess(code) {
            // console.log(code);
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        },
        loadMyJoinTeam() {
            return request({
                url: '/team/getMyJoinTeams',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    // debugger;
                    this.team.myJoin = res.data;
                }
            });
        },
    }
};
</script>

<style>
.el-main {
    /* background-color: #e9eef3; */
    /* color: #333; */
    text-align: left;
}

.el-card {
    margin: 10px;
}

.exe-log-time {
    display: flex;
    flex-direction: column;
    line-height: 1.4;
}

.exe-log-address {
    color: #909399;
    font-size: 12px;
}

.exe-log-search {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding: 16px 20px;
    background-color: #f5f7fa;
    border-radius: 6px;
}

.exe-log-search .el-input {
    width: 220px;
}

.exe-log-search .el-button .el-icon {
    margin-right: 4px;
}

.exe-log-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

.exe-log-detail {
    margin-bottom: 16px;
}

.exe-log-script {
    white-space: pre-wrap;
    word-break: break-all;
}
</style>
